<div class="align-items-center has-border ordersummary-header pb-2 mt-3">
  <h3 class="m-0 wordwrap sec-title mb-2">Recipients</h3>

  <div class="d-flex">
    <div class="ordersummary-panel ml-auto d-flex justify-content-between">
      <div class="nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="onAdd()"><i class="pi pi-plus"></i> Add</a>
      </div>
    </div>
    <div class="ordersummary-panel ml-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link delcol" (click)="onDelete()"
          ><i class="pi pi-trash"></i> Delete</a
        >
      </div>
    </div>
  </div>
</div>

<p-table
  #dt
  stripedRows
  [value]="recipientsList"
  [(selection)]="recipientsListSelected"
  styleClass="p-datatable-customers order-listing"
  [rowHover]="true"
  [rows]="25"
  [size]="'small'"
  [scrollable]="true"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [paginator]="false"
  [filterDelay]="0"
  dataKey="id"
  editMode="row"
  selectionMode="multiple"
  styleClass="table-listing">
  <ng-template pTemplate="header">
    <tr class="table-head">
      <th class="col-center" style="width: 3rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th class="name">Recipient</th>
      <th class="vaccount">Display name</th>
      <th class="sname">Recipient type</th>
      <th class="sname">Primary</th>
      <th class="sname">Add Type</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-addressBookLists
    let-rowIndex="rowIndex"
    let-editing="editing">
    <tr class="p-selectable-row" [pSelectableRow]="addressBookLists">
      <td>
        <p-tableCheckbox
          [value]="addressBookLists"
          [pSelectableRow]="addressBookLists"></p-tableCheckbox>
      </td>
      <td
        [pEditableColumn]="addressBookLists.locatorD365"
        pEditableColumnField="locatorD365"
        [ngClass]="{ 'bg-red': addressBookLists.locatorD365 === '' }">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              style="width: 100%"
              [(ngModel)]="addressBookLists.locatorD365"
              required />
          </ng-template>
          <ng-template pTemplate="output">
            {{ addressBookLists.locatorD365 }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td
        [pEditableColumn]="addressBookLists.descriptionD365"
        pEditableColumnField="descriptionD365">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              style="width: 100%"
              [(ngModel)]="addressBookLists.descriptionD365"
              required />
          </ng-template>
          <ng-template pTemplate="output">
            {{ addressBookLists.descriptionD365 }}
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        {{ addressBookLists.purposeD365 }}
      </td>
      <td>
        {{ addressBookLists.isPrimaryD365 | titlecase }}
      </td>
      <td
        [pEditableColumn]="addressBookLists.addType"
        pEditableColumnField="addType">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <select class="form-select" [(ngModel)]="addressBookLists.addType">
              <option>TO</option>
              <option>CC</option>
            </select>
          </ng-template>
          <ng-template pTemplate="output">
            {{ addressBookLists.addType }}
          </ng-template>
        </p-cellEditor>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="20">No Recipients found.</td>
    </tr>
  </ng-template>
</p-table>
